import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '电影平台', path: '/category/dianying' },
      { label: '电视剧平台', path: '/category/dianshiju' },
      { label: '纪录片平台', path: '/category/jilupian' },
      { label: '动漫平台', path: '/category/dongman' },
      { label: '综艺平台', path: '/category/zongyi' },
    ],
  },
  {
    title: '推荐阅读',
    links: [
      { label: '免费电影平台推荐', path: '/article/2024-top-5-free-movie-platforms' },
      { label: '电视剧平台对比', path: '/article/free-drama-platforms-comparison' },
      { label: '纪录片平台推荐', path: '/article/free-documentary-platforms' },
      { label: '动漫平台攻略', path: '/article/free-anime-platforms-guide' },
      { label: '安全观影指南', path: '/article/safe-streaming-platform-guide' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about#contact' },
      { label: '用户反馈', path: '/about#feedback' },
    ],
  },
];

const categoryItems = [
  { label: '电影', path: '/category/dianying' },
  { label: '电视剧', path: '/category/dianshiju' },
  { label: '纪录片', path: '/category/jilupian' },
  { label: '动漫', path: '/category/dongman' },
  { label: '综艺', path: '/category/zongyi' },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <i className="ri-movie-2-line text-primary-500 text-xl w-6 h-6 flex items-center justify-center"></i>
              <span className="font-heading text-base font-bold text-foreground-900 whitespace-nowrap">
                免费看片推荐
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              致力于为用户推荐安全合规的正版免费影视平台，涵盖电影、电视剧、纪录片、动漫、综艺等海量资源，助你轻松发现好片。
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2024 免费看片平台推荐. 本站为信息聚合平台，不提供视频播放服务。所有平台推荐均基于客观评测。
          </p>
          <div className="flex items-center gap-4">
            {categoryItems.map((cat) => (
              <Link
                key={cat.path}
                to={cat.path}
                className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {cat.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}